<template>
  <fs-modal ref="modalRef" is-error @close="onClose">
    <div class="modal">
      <h2>BOM connections would be dropped</h2>
      <p>{{ bomDataLossModal.message.value }}</p>
      <p class="modal__warning">Continue and accept that these connections will be permanently lost?</p>
      <button-pair
        class="modal__buttons"
        action-btn-name="Proceed"
        cancel-btn-name="Cancel"
        @action="bomDataLossModal.resolve(true)"
        @cancel="bomDataLossModal.resolve(false)"
      />
    </div>
  </fs-modal>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import FsModal from '@components/modals/fs-modal.vue';
import ButtonPair from '@components/button-pair.vue';
import { bomDataLossModal } from '@lib/bom-data-loss';

const modalRef = ref<InstanceType<typeof FsModal> | null>(null);

watch(bomDataLossModal.isOpen, (isOpen) => {
  if (isOpen) modalRef.value?.open();
  else modalRef.value?.close();
});

function onClose() {
  if (bomDataLossModal.isOpen.value) bomDataLossModal.resolve(false);
}
</script>

<style scoped lang="scss">
@import '@styles/variables';
@import '@styles/text';

.modal {
  padding: 2.4rem;
  min-width: 50rem;

  h2 {
    @include popper-title;
    margin: 0 0 2rem 0;
  }

  p {
    margin: 0 0 1.6rem 0;
    color: $c-dark-light;
    line-height: 1.5;
  }

  &__warning {
    color: $c-error;
    font-size: 1.3rem;
    font-style: italic;
  }

  &__buttons {
    margin-top: 3rem;
  }
}
</style>
